import type { Client } from "~/types";
import { objectEntries, waitForElement } from "./general";
import { formatPhone } from "./format";

export function openChatbox() {
  setChatVisibility(true);
  window.$crisp!.push(["do", "chat:open"]);
}

export function onChatClose(cb: () => void) {
  window.$crisp!.push(["on", "chat:closed", cb]);
}

export function setChatContact({ name, email, phone }: Client) {
  const map = { nickname: name, email, phone };
  for (const [key, val] of objectEntries(map)) {
    if (val) try {
      window.$crisp.push([
        "set",
        "user:" + key,
        [typeof val == 'string' ? val : formatPhone(val)]
      ]);
    } catch (e) {
      console.error(e);
    }
  }
}

export function disableChatWarnings() {
  window.$crisp.push(["safe", true]);
}

export function setChatVisibility(visible: boolean) {
  visible ? show() : hide();
}

async function hide() {
  const classList = await getButtonClassList();
  classList?.add('hidden');
}
async function show() {
  const classList = await getButtonClassList();
  classList?.remove('hidden');
}
async function getButtonClassList() {
  const el = await waitForElement('#crisp-chatbox');
  return el?.classList;
}